export default "__VITE_ASSET__lmG6rO$3__"